import { css } from '@emotion/css';

export const bankAccountVerificationCx = css`
  h6 {
    margin-bottom: 16px;
  }

  .bank-wrapper {
    background: var(--colors-primary-10);
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;

    p {
      margin: 0;
    }

    p:nth-of-type(2) {
      margin-botton: 10px;
    }
  }

  .illustration {
    width: 100%;
    margin-bottom: 1rem;
  }

  .warning-box {
    background: var(--colors-neutrals-20);
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 24px;

    h6 {
      margin-bottom: 0px;
    }

    & > div {
      display: flex;
      align-items: center;
      gap: 8px;

      svg {
        flex-shrink: 0;
      }
    }
  }

  .action {
    display: flex;
    gap: 16px;
  }
`;
